import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ViewRequestLink = styled(Link)`
  background: none;
  border: none;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font: inherit;

  &:hover {
    opacity: 0.8;
  }
`;
